import { useSyncExternalStore } from "react";

function subscribe() {
  return () => {};
}

/**
 * `false` while rendering prerendered HTML and during hydration, `true` after.
 * Use it for UI that depends on per-visitor browser state (storage, consent).
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
